import { MainContainer } from 'components/page/containers/MainContainer'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'
import { Box, Drawer, List, ListItem, Typography } from '@material-ui/core'

import { Search, ChevronRight } from '@material-ui/icons'
import { Button } from 'common/atoms/Button/Button'
import { JobSearchFilterIcon } from 'common/icon-components/JobSearchFilterIcon'
import { InputFieldGroup } from 'common/molecules/InputFieldGroup/InputFieldGroup'
import { Select } from 'common/molecules/Select/Select'
import { IJobProps, JobProps, JobSortEnum } from 'common/types/job.types'
import { StyledJobSearchButton } from './styles'
import { JobDetails } from 'pages/content/components/jobs/JobDetails'
import { SubscriptionLimitModal } from 'pages/profile/components/partner-profile/SubscriptionLimitModal'
import { useTheme } from 'styled-components'
import {
  StyledContainer,
  StyledInnerContainer,
  StyledLeftContainer,
  StyledRightCard
} from '../content/components/jobs/styled'
import { JobsList } from './JobsList'
import { JobsFilterDrawer } from './components/JobsFilterDrawer'
import { useJobsPage } from './hooks/useJobsPage'
import {
  StyledCaretContainer,
  StyledFilterDrawerItem,
  StyledFiltersContainer,
  StyledJobSearchContainer,
  StyledJobsFilterDrawerContainer
} from './components/styles'
import { JobsNotFound } from './components/JobsNotFound'
import {
  jobTypeList,
  workplaceList,
  datePosted,
  filterCountryList,
  countryList
} from 'pages/content/components/jobs/components/template/JobFormMobile/data'
import DateFnsUtils from '@date-io/date-fns'
import { countries } from 'common/select-options'
import { NavBar } from 'components/page/nav-bar'
import { Loader } from 'components/core/loader'
import { DrawerTopBar } from './components/DrawerTopBar'
import { DrawerFilterOptions } from './components/DrawerFilterOptions'
import { CountryNames } from 'pages/content/components/jobs/components/template/JobFormMobile/types'

export interface JobsListResponse {
  page: string
  pageSize: string
  dir: JobSortEnum
  sort: string
  totalCount: string
  data: JobProps[]
}

const JobsPage = () => {
  const {
    backendUser,
    backendPartner,
    jobDrawer,
    setJobDrawer,
    jobs,
    lastResponse,
    filter,
    setFilter,
    handleJobClick,
    selectedJob,
    showJobLimitModal,
    setShowJobLimitModal,
    setSearchCriteria,
    trackJobSearchEvent,
    handlePageChange,
    setSelectedJob,
    fetchingJobs,
    showFiltersCaret,
    datePostedDrawerOpen,
    setDatePostedDrawerOpen,
    jobTypeDrawerOpen,
    setJobTypeDrawerOpen,
    workplaceDrawerOpen,
    setWorkplaceDrawerOpen,
    countryDrawerOpen,
    onValueChange,
    isCanadaOrUS,
    setIsCanadaOrUS,
    provinceList,
    cityList,
    setCountryDrawerOpen,
    getProfilePercentage,
    page,
    provinceDrawerOpen,
    setProvinceDrawerOpen,
    cityDrawerOpen,
    setCityDrawerOpen
  } = useJobsPage()
  const theme = useTheme()
  const { inviteUsersByEmail } = useOnboarding()
  const { isDevice } = useScreenSizes()

  return (
    <>
      <MainContainer
        inviteUsersByEmail={inviteUsersByEmail}
        nopadding
        hideLogo={!backendUser ? true : false}
        stickTopBar={backendUser ? true : false}
        user={backendUser}
        showAvatar={backendUser ? true : false}
        hideFooter={!backendUser && isDevice ? true : false}
        title={`Jobs`}
        showSearch={!isDevice}
      >
        {!backendUser && (
          <NavBar
            inviteUsersByEmail={inviteUsersByEmail}
            backendUser={backendUser}
            getProfilePercentage={getProfilePercentage(backendUser)}
          />
        )}
        <Box px="0.875rem">
          <StyledJobSearchContainer
            display="flex"
            flexDirection="column"
            gridGap="0.75rem"
            width="100%"
            minWidth="0"
            maxWidth="77em"
            margin="0 auto"
            marginBottom="1.4375rem"
            marginTop="1.4375rem"
            p={isDevice ? '0.6875rem 0.8125rem' : '1.125rem 1.625rem'}
            bgcolor={theme.colors.supplementary}
            borderRadius="1rem"
            id="jobs-search-container"
          >
            <Box display="grid" gridTemplateColumns="20fr 1fr" justifyItems="end" alignItems="center" gridGap="0.5rem">
              <InputFieldGroup
                placeholder="Search by Role or Company"
                startAdornment={
                  <Box display="flex" justifyContent="center" alignItems="center" ml={isDevice ? '0.875rem' : '2rem'}>
                    <Search htmlColor={theme.colors.primary} />
                  </Box>
                }
                onChange={event => {
                  setSearchCriteria(event?.target.value)
                  trackJobSearchEvent()
                }}
              />
              <StyledJobSearchButton onClick={() => setJobDrawer(true)}>
                <JobSearchFilterIcon />
              </StyledJobSearchButton>
            </Box>
            <Box display={isDevice ? 'block' : 'flex'} alignItems="center" justifyItems="center">
              <Box justifyContent="flex-start" alignItems="center" position="relative">
                <StyledFiltersContainer className={isDevice ? 'mobile' : 'desktop'} isCanadaOrUS={isCanadaOrUS && true}>
                  {!isDevice && (
                    <>
                      <Select
                        design="small"
                        name="datePosted"
                        width="100%"
                        menuItemList={datePosted}
                        value={filter?.[IJobProps.DATE_POSTED] || ''}
                        theme={theme}
                        placeholder="Date Posted"
                        autoWidth={true}
                        multiple={false}
                        native={false}
                        onChange={e => {
                          onValueChange(e)
                        }}
                      />
                      <Select
                        design="small"
                        name="jobType"
                        width="100%"
                        menuItemList={jobTypeList}
                        value={filter?.[IJobProps.JOB_TYPE] || ''}
                        theme={theme}
                        placeholder="Job Type"
                        onChange={e => {
                          onValueChange(e)
                        }}
                        menuItemWidth="370px"
                      />
                      <Select
                        design="small"
                        name="workplace"
                        width="100%"
                        menuItemList={workplaceList}
                        value={filter?.[IJobProps.WORKPLACE] || ''}
                        theme={theme}
                        placeholder="Workplace"
                        onChange={e => {
                          onValueChange(e)
                        }}
                      />
                    </>
                  )}
                  <Select
                    design="small"
                    useCustomOpenFnc={isDevice}
                    name="country"
                    width="100%"
                    menuItemList={filterCountryList}
                    value={filter?.[IJobProps.COUNTRY] || ''}
                    theme={theme}
                    placeholder="Country"
                    onOpen={() => {
                      setCountryDrawerOpen(true)
                    }}
                    onChange={e => {
                      onValueChange(e)
                    }}
                    menuItemWidth="430px"
                  />
                  {isDevice && (
                    <Drawer
                      anchor="bottom"
                      open={countryDrawerOpen}
                      onClose={() => {
                        setCountryDrawerOpen(false)
                      }}
                    >
                      <DrawerFilterOptions
                        list={filterCountryList}
                        label="Select Country"
                        name={IJobProps.COUNTRY}
                        setDrawerOpen={setCountryDrawerOpen}
                        onValueChange={onValueChange}
                      />
                    </Drawer>
                  )}
                  {isCanadaOrUS && (
                    <>
                      <Select
                        design="small"
                        useCustomOpenFnc={isDevice}
                        name="province"
                        width="100%"
                        menuItemList={provinceList}
                        value={filter?.[IJobProps.PROVINCES] || ''}
                        theme={theme}
                        placeholder={
                          filter?.[IJobProps.COUNTRY] == CountryNames.OUTSIDE_NA_SELECT_VALUE ? 'Province' : 'State'
                        }
                        onOpen={() => {
                          setProvinceDrawerOpen(true)
                        }}
                        onChange={e => {
                          onValueChange(e)
                        }}
                        menuItemWidth="520px"
                        disabled={filter?.[IJobProps.COUNTRY] == CountryNames.OUTSIDE_NA_SELECT_VALUE}
                      />
                      {isDevice && (
                        <Drawer
                          anchor="bottom"
                          open={provinceDrawerOpen}
                          onClose={() => {
                            setProvinceDrawerOpen(false)
                          }}
                        >
                          <DrawerFilterOptions
                            list={provinceList}
                            label={
                              filter?.[IJobProps.COUNTRY] == CountryNames.OUTSIDE_NA_SELECT_VALUE
                                ? 'Select Province'
                                : 'Select State'
                            }
                            name={IJobProps.PROVINCES}
                            setDrawerOpen={setProvinceDrawerOpen}
                            onValueChange={onValueChange}
                          />
                        </Drawer>
                      )}
                      <Select
                        design="small"
                        useCustomOpenFnc={isDevice}
                        name="city"
                        width="100%"
                        menuItemList={cityList}
                        value={filter?.[IJobProps.CITY] || ''}
                        theme={theme}
                        placeholder="City"
                        onOpen={() => {
                          setCityDrawerOpen(true)
                        }}
                        onChange={e => {
                          onValueChange(e)
                        }}
                        disabled={!filter?.[IJobProps.PROVINCES]}
                        menuItemWidth="600px"
                      />
                      {isDevice && (
                        <Drawer
                          anchor="bottom"
                          open={cityDrawerOpen}
                          onClose={() => {
                            setCityDrawerOpen(false)
                          }}
                        >
                          <DrawerFilterOptions
                            list={cityList}
                            label="Select City"
                            name={IJobProps.CITY}
                            setDrawerOpen={setCityDrawerOpen}
                            onValueChange={onValueChange}
                          />
                        </Drawer>
                      )}
                    </>
                  )}
                </StyledFiltersContainer>
              </Box>
              {Object.keys(filter)
                .filter(key => {
                  return [
                    IJobProps.DATE_POSTED,
                    IJobProps.JOB_TYPE,
                    IJobProps.WORKPLACE,
                    IJobProps.COUNTRY,
                    IJobProps.PROVINCES,
                    IJobProps.CITY
                  ].includes(key as any)
                })
                .map(key => filter[key])
                .some(val => !!val) && (
                <Box display="flex" justifyContent="flex-end" ml="1.375rem">
                  <Button
                    design="tertiary"
                    onClick={() => {
                      setFilter({
                        ...filter,
                        [IJobProps.DATE_POSTED]: '',
                        [IJobProps.JOB_TYPE]: '',
                        [IJobProps.WORKPLACE]: '',
                        [IJobProps.COUNTRY]: '',
                        [IJobProps.PROVINCES]: '',
                        [IJobProps.CITY]: ''
                      })
                      setIsCanadaOrUS('')
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              )}
            </Box>
          </StyledJobSearchContainer>
          <StyledContainer display="flex" gridGap="1.125rem">
            <Box width="100%" height="100%">
              <StyledLeftContainer width={'100%'} height="100%" display="grid" gridTemplateRows="1fr">
                {fetchingJobs ? (
                  <Loader />
                ) : (
                  <JobsList
                    jobsList={jobs}
                    handleJobClick={handleJobClick}
                    selectedJob={selectedJob}
                    totalPages={
                      Math.ceil(
                        parseInt(lastResponse?.totalCount?.toString()) / parseInt(lastResponse?.pageSize?.toString())
                      ) || page
                    }
                    currentPage={page}
                    handlePageChange={handlePageChange}
                    loading={fetchingJobs}
                  />
                )}
              </StyledLeftContainer>
            </Box>

            {!isDevice && (
              <StyledInnerContainer
                flexBasis="67%"
                flexShrink="0"
                width="100%"
                height="calc(100vh - 172px)"
                position="sticky"
                top="calc(1.4375rem + 70px)"
                overflow="hidden !important"
                paddingTop="0"
                pr={!isDevice && '0'}
              >
                {!fetchingJobs && jobs?.length < 1 ? (
                  <JobsNotFound />
                ) : (
                  <StyledRightCard>
                    <JobDetails job={selectedJob} scrollDescriptionSection openInNewTab />
                  </StyledRightCard>
                )}
              </StyledInnerContainer>
            )}
          </StyledContainer>
        </Box>
        <SubscriptionLimitModal show={showJobLimitModal} setShow={setShowJobLimitModal} subscriptionType="Jobs" />
      </MainContainer>
      <JobsFilterDrawer isDrawerOpen={jobDrawer} setIsDrawerOpen={setJobDrawer} filter={filter} setFilter={setFilter} />
    </>
  )
}

export default JobsPage
